function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" {...props}><path d="M25.973 16c0 5.803-4.704 10.507-10.507 10.507S4.959 21.803 4.959 16 9.663 5.493 15.466 5.493 25.973 10.197 25.973 16z" /><path fill="#fff" d="M13.666 17.644H9.089a.618.618 0 0 1-.596-.594v-2.196a.616.616 0 0 1 .595-.595h4.578V9.654a.586.586 0 0 1 .586-.564H16.464c.316 0 .574.25.586.563v4.609h4.607c.314.012.564.27.564.586V17.06c0 .316-.25.574-.563.586h-4.609v4.577a.586.586 0 0 1-.586.564H14.251a.586.586 0 0 1-.586-.563v-4.579z" /></svg>;
});